import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskTimelineComponent } from './task-timeline/task-timeline';
import { DailySummaryComponent } from './daily-summary/daily-summary';
import { MyReportingComponent } from './my-reporting/my-reporting';

@Component({
  selector: 'app-activity',
  imports: [CommonModule, TaskTimelineComponent, DailySummaryComponent, MyReportingComponent],
  templateUrl: './activity.html',
  styleUrl: './activity.scss',
})
export class Activity {
  activeTab: 'timeline' | 'summary' | 'reporting' = 'timeline';

  switchTab(tab: 'timeline' | 'summary' | 'reporting') {
    this.activeTab = tab;
  }

  /** Contextual subtitle, e.g. "Time tracking · week of 23 Jun". */
  get subtitle(): string {
    const now = new Date();
    const day = now.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Monday of the current week
    const monday = new Date(now);
    monday.setDate(now.getDate() + diff);
    const label = monday.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    return `Time tracking · week of ${label}`;
  }
}
